import { BaseRequest } from "internal";

class UnAuthenticatedRequest extends BaseRequest {}

export default UnAuthenticatedRequest;
